var map = {
	"./header_logo.png": "AMc/",
	"./img_tags/image_tag_card.png": "kASg",
	"./img_tags/image_tag_ex_point.png": "I1lA",
	"./img_tags/image_tag_get_point.png": "aC7f",
	"./img_tags/image_tag_point_exchange.png": "BqJX",
	"./img_tags/image_tag_present.png": "rSjr",
	"./svg/sai-icon_click.svg": "BUCt"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "s0Fw";